import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { PencilIcon, SearchIcon } from '@primer/octicons-react'
import { BiCalendar, BiDownload, BiImage, BiLink, /*BiTrash,*/ BiUnlink, /*BiUpload,*/ BiXCircle } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { HiOutlineEye } from "react-icons/hi";
import LocPickerDialog from './LocPickerDialog';
//import QRCode from 'react-qr-code';
import DateTimePicker from 'react-datetime-picker';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import { axiosAuth_BLDG_DATA_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate, formatDateOnly } from '../utils/timeUtils';
import { formatFileSize, isNaturalNumber } from '../utils/jsUtils';
import { filterArray } from '../utils/jsUtils';
import configInfo from '../config/config.json';

const AssetAdminDetailsView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const locale = i18n.language.replace("_", "-");
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    name: '',
    nameLang2: '',
    description: '',
    typeid: '',
    typeCode: '',
    mfr: '',
    brand: '',
    model: '',
    modelNum: '',
    serialNum: '',
    locId: '',
    locCode: '',
    mfrDate: '',
    installDate: '',
    status: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const [currentObjAttrs,         setCurrentObjAttrs]        = useState([]);

  const [typeSpecAttrs,           setTypeSpecAttrs]           = useState([]);
  const [profilePhoto,            setProfilePhoto]            = useState(null);
  const [docList,                 setDocList]                 = useState([]);
  const [docPickerMode,           setDocPickerMode]           = useState(null);

  const [handoverDate,            setHandoverDate]            = useState(null);
  const [installDate,             setInstallDate]             = useState(null);
  const [firstUseDate,            setFirstUseDate]            = useState(null);
  const [warrStartDate,           setWarrStartDate]           = useState(null);
  const [warrEndDate,             setWarrEndDate]             = useState(null);
//const [mfrDate,                 setMfrDate]                 = useState(null);

  const [showTypeSelectDialog,    setShowTypeSelectDialog]    = useState(false);
  const [typeSearchTerm,          setTypeSearchTerm]          = useState('');
  const [typeList,                setTypeList]                = useState('');
  const [errMsg_TypeSelect,       setErrMsg_TypeSelect]       = useState('');

  const [locPickerMode,           setLocPickerMode]           = useState(null);
  const [showLocPickerDialog,     setShowLocPickerDialog]     = useState(false);

  const [showDocSelectDialog,     setShowDocSelectDialog]     = useState(false);
  const [docSearchTerm,           setDocSearchTerm]           = useState('');
  const [docCandidateList,        setDocCandidateList]        = useState('');
  const [errMsg_DocSelect,        setErrMsg_DocSelect]        = useState('');

  const [docToPreview,            setDocToPreview]            = useState(null);
  const [showDocPreviewDialog,    setPreviewDialog]           = useState(false);

  const [unlinkTarget,            setUnlinkTarget]            = useState();
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [errMsgUnlinkConfirm,     setErrMsgUnlinkConfirm]     = useState('')

  // UI Functions

  // Initialize state
  useEffect(() => {

    if (props) {
      fetchObj(props.objDetails.id);
      fetchDocs(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("assets/" + id);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {

          setObjAttrs(res.data[0]);
          setCurrentObjAttrs(res.data[0]);

          fetchTypeSpecAttrs(res.data[0].typeCode);

          if (res.data[0].photoId) {
            fetchProfilePhoto(res.data[0].photoPath, res.data[0].photoFileType);
          } else {
            setProfilePhoto(null);
          }

/*
          if (props.objDetails.mfrDate) {
            setHandoverDate(new Date(props.objDetails.mfrDate));
          }
*/

          if (props.objDetails.handoverDate) {
            setHandoverDate(new Date(props.objDetails.handoverDate));
          }

          if (props.objDetails.installDate) {
            setInstallDate(new Date(props.objDetails.installDate));
          }

          if (props.objDetails.firstUseDate) {
            setFirstUseDate(new Date(props.objDetails.firstUseDate));
          }

          if (props.objDetails.warrStartDate) {
            setWarrStartDate(new Date(props.objDetails.warrStartDate));
          }

          if (props.objDetails.warrEndDate) {
            setWarrEndDate(new Date(props.objDetails.warrEndDate));
          }
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchTypeSpecAttrs = (typeCode) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=OBJ_TYPE_SPECIFIC_ATTRS");

        resolve(res.data);
        if (res.status === 200) {

          if (   res.data
              && res.data[0]
              && res.data[0].config
              && res.data[0].config.ASSET
              && res.data[0].config.ASSET[typeCode]) {

            setTypeSpecAttrs (res.data[0].config.ASSET[typeCode]);
/*
setTypeSpecAttrs([
'pumpHead',
'pumpWaterFlow',
'motorPower',
'motorSpeed',
'coolingCap',
'evapFlowRate',
'condFlowRate',
'cop',
'heatRejection',
'waterFlowRate',
'airFlowRate',
'staticPressure',
'ratedLoad',
'ratedSpeed',
'powerRange'
]);
*/
          }
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchProfilePhoto = (path, fileType) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_BLDG_DATA_API.get(`/files?path=${encodeURIComponent(path)}`, {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: fileType });
          const blobUrl = URL.createObjectURL(blob);

          setProfilePhoto(blobUrl);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchDocs = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("assets/" + id + "/docs");

        resolve(res.data);

        if (res.status === 200) {
          for (let i=0; i<res.data.length; i++) {
            res.data[i].viewType = ( res.data[i].fileType.startsWith('image') ? 'IMAGE' :
                                     (res.data[i].fileType.indexOf('application/pdf') >= 0) ? 'PDF' :
                                     'NONE');
          }

          setDocList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  const statusList = [
    { key: "IN_USE",   value: "IN_USE" },
    { key: "IDLE",     value: "IDLE" },
    { key: "DISPOSED", value: "DISPOSED" }
  ];

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onAttrsInputChangeInt = (e) => {

    if (isNaturalNumber(e.target.value)) {
      // Convert to a number
      setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value * 1.0 })
    } else {
      // Leave it be, and let validation logic before submit to handle it.
      setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
    }
  }

/*
  const onDatepickerChangeMfrDate = (value) => {
    setMfrDate(value);
  }
*/

  const onDatepickerChangeHandoverDate = (value) => {
    setHandoverDate(value);
  }

  const onDatepickerChangeInstallDate = (value) => {
    setInstallDate(value);
  }

  const onDatepickerChangeFirstUseDate = (value) => {
    setFirstUseDate(value);
  }

  const onDatepickerChangeWarrStartDate = (value) => {
    setWarrStartDate(value);
  }

  const onDatepickerChangeWarrEndDate = (value) => {
    setWarrEndDate(value);
  }

  const onAssetStatusSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, status: key })
  };


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setObjAttrs(currentObjAttrs);

/*
    if (currentObjAttrs.handoverDate) {
      setHandoverDate(new Date(currentObjAttrs.handoverDate));
    }
*/

    if (currentObjAttrs.handoverDate) {
      setHandoverDate(new Date(currentObjAttrs.handoverDate));
    }

    if (currentObjAttrs.installDate) {
      setInstallDate(new Date(currentObjAttrs.installDate));
    }

    if (currentObjAttrs.firstUseDate) {
      setFirstUseDate(new Date(currentObjAttrs.firstUseDate));
    }

    if (currentObjAttrs.warrStartDate) {
      setWarrStartDate(new Date(currentObjAttrs.warrStartDate));
    }

    if (currentObjAttrs.warrEndDate) {
      setWarrEndDate(new Date(currentObjAttrs.warrEndDate));
    }

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    let currentTime = (new Date()).getTime();

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");
      return;

/*
    } else if (!objAttrs.nameLang2 || objAttrs.nameLang2.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_2") + ")");
      return;
*/
    } else if (objAttrs.nameLang2 && (objAttrs.nameLang2 != null) && objAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

/*
    } else if (!objAttrs.nameLang3 || objAttrs.nameLang3.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_3") + ")");
      return;
*/
    } else if (objAttrs.nameLang3 && (objAttrs.nameLang3 != null) && objAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");
      return;

    } else if (!objAttrs.typeCode || objAttrs.typeCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_asset_type"));
      return;

    } else if (objAttrs.code.indexOf(objAttrs.typeCode) < 0) {
      setErrMsg(t("I18N_ERR_Asset_code_must_contain_type"));
      return;

    } else if (objAttrs.nativeCode && objAttrs.nativeCode.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_native_code") + "50");
      return;

/* Not required
    } else if (!objAttrs.locCode || objAttrs.locCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_loc"));
      return;

    } else if (!objAttrs.typeCode || objAttrs.typeCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_serv_loc"));
      return;
*/

    } else if (objAttrs.brand && objAttrs.brand.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_brand") + "100");
      return;

    } else if (objAttrs.model && objAttrs.model.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_model") + "100");
      return;

    } else if (objAttrs.modelNum && objAttrs.modelNum.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_model_num") + "50");
      return;

    } else if (objAttrs.serialNum && objAttrs.serialNum.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_serial_num") + "50");
      return;

    } else if (objAttrs.mfr && objAttrs.mfr.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_mfr") + "100");
      return;

    } else if (objAttrs.website && objAttrs.website.length > 1000) {
      setErrMsg(t("I18N_ERR_Max_len_website") + "1000");
      return;

    } else if (objAttrs.countryOfOrigin && objAttrs.countryOfOrigin.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_country_of_orig") + "100");
      return;

    } else if (objAttrs.vendor && objAttrs.vendor.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_vendor") + "100");
      return;

    } else if (objAttrs.length &&
               (!isNaturalNumber(objAttrs.length)  || (objAttrs.length > 2147483647))) {
      setErrMsg(t("I18N_Length") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.width &&
               (!isNaturalNumber(objAttrs.width)   || (objAttrs.width  > 2147483647))) {
      setErrMsg(t("I18N_Width") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.height &&
               (!isNaturalNumber(objAttrs.height)  || (objAttrs.height > 2147483647))) {
      setErrMsg(t("I18N_Height") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.weight &&
               (!isNaturalNumber(objAttrs.weight) || (objAttrs.weight > 2147483647))) {
      setErrMsg(t("I18N_Weight") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.pumpHead && (objAttrs.pumpHead.length > 0) && isNaN(objAttrs.pumpHead)) {
      setErrMsg(t("I18N_pumpHead") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.pumpWaterFlow && (objAttrs.pumpWaterFlow.length > 0) && isNaN(objAttrs.pumpWaterFlow)) {
      setErrMsg(t("I18N_pumpWaterFlow") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.motorPower && (objAttrs.motorPower.length > 0) && isNaN(objAttrs.motorPower)) {
      setErrMsg(t("I18N_motorPower") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.motorSpeed && (objAttrs.motorSpeed.length > 0) && isNaN(objAttrs.motorSpeed)) {
      setErrMsg(t("I18N_motorSpeed") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.coolingCap && (objAttrs.coolingCap.length > 0) && isNaN(objAttrs.coolingCap)) {
      setErrMsg(t("I18N_coolingCap") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.evapFlowRate && (objAttrs.evapFlowRate.length > 0) && isNaN(objAttrs.evapFlowRate)) {
      setErrMsg(t("I18N_evapFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.condFlowRate && (objAttrs.condFlowRate.length > 0) && isNaN(objAttrs.condFlowRate)) {
      setErrMsg(t("I18N_condFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.cop && (objAttrs.cop.length > 0) && isNaN(objAttrs.cop)) {
      setErrMsg(t("I18N_cop") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.heatRejection && (objAttrs.heatRejection.length > 0) && isNaN(objAttrs.heatRejection)) {
      setErrMsg(t("I18N_heatRejection") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.waterFlowRate && (objAttrs.waterFlowRate.length > 0) && isNaN(objAttrs.waterFlowRate)) {
      setErrMsg(t("I18N_waterFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.airFlowRate && (objAttrs.airFlowRate.length > 0) && isNaN(objAttrs.airFlowRate)) {
      setErrMsg(t("I18N_airFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.staticPressure && (objAttrs.staticPressure.length > 0) && isNaN(objAttrs.staticPressure)) {
      setErrMsg(t("I18N_staticPressure") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.ratedLoad && (objAttrs.ratedLoad.length > 0) && isNaN(objAttrs.ratedLoad)) {
      setErrMsg(t("I18N_ratedLoad") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.ratedSpeed && (objAttrs.ratedSpeed.length > 0) && isNaN(objAttrs.ratedSpeed)) {
      setErrMsg(t("I18N_ratedSpeed") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.powerRange && (objAttrs.powerRange.length > 0) && isNaN(objAttrs.powerRange)) {
      setErrMsg(t("I18N_powerRange") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (!objAttrs.status || (objAttrs.status.length === 0)) {
      setErrMsg(t("I18N_ERR_Need_state"));
      return;

    } else if (handoverDate && ((handoverDate.getTime() - currentTime) > 0)) {
      setErrMsg(t("I18N_handoverDate") + t("I18N_ERR_Date_must_be_in_past"));
      return;

    } else if (installDate && ((installDate.getTime() - currentTime) > 0)) {
      setErrMsg(t("I18N_installDate") + t("I18N_ERR_Date_must_be_in_past"));
      return;

    } else if (firstUseDate && ((firstUseDate.getTime() - currentTime) > 0)) {
      setErrMsg(t("I18N_firstUseDate") + t("I18N_ERR_Date_must_be_in_past"));
      return;

    } else if (warrStartDate && ((warrStartDate.getTime() - currentTime) > 10 * 356 * 24 * 60 * 60 * 1000)) {
      setErrMsg(t("I18N_warrStartDate") + t("I18N_ERR_Date_10_yr_in_future_limit"));
      return;

    } else if (warrEndDate && ((warrEndDate.getTime() - currentTime) > 10 * 356 * 24 * 60 * 60 * 1000)) {
      setErrMsg(t("I18N_warrEndDate") + t("I18N_ERR_Date_20_yr_in_future_limit"));
      return;

    } else if (warrStartDate && warrEndDate && (warrEndDate.getTime() < warrStartDate.getTime())) {
      setErrMsg(t("I18N_ERR_Warr_End_GT_Start_time"));
      return;
    }

    // Deep copy
    let reqBody = JSON.parse(JSON.stringify(objAttrs));
    reqBody.raw = null;

    // Get the date type attributes
    reqBody.handoverDate  = handoverDate;
    reqBody.installDate   = installDate;
    reqBody.firstUseDate  = firstUseDate;
    reqBody.warrStartDate = warrStartDate;
    reqBody.warrEndDate   = warrEndDate;

/*
    reqBody.mfrDate       = (mfrDate       ? mfrDate.toISOString()       : "");
*/
    reqBody.handoverDate  = (handoverDate  ? handoverDate.toISOString()  : "");
    reqBody.installDate   = (installDate   ? installDate.toISOString()   : "");
    reqBody.firstUseDate  = (firstUseDate  ? firstUseDate.toISOString()  : "");
    reqBody.warrStartDate = (warrStartDate ? warrStartDate.toISOString() : "");
    reqBody.warrEndDate   = (warrEndDate   ? warrEndDate.toISOString()   : "");

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.put("assets/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);

          fetchObj(objAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }



  // --- Asset type select dialog stuff ---

  const handleTypePicker = (e) => {
    setErrMsg_TypeSelect('');
    setShowTypeSelectDialog(true);
  }

  const handleTypeSearch = (e) => {
    e.preventDefault();

    if (typeSearchTerm === '') {
      setTypeSearchTerm('');
      setTypeList([]);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("asset-types?searchTerms=" + typeSearchTerm);

        resolve(res.data);

        if (res.status === 200) {
          setTypeList(res.data.data);
        }

        setErrMsg_TypeSelect('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_TypeSelect(t(translateAPIError(error)));
        }
      }
    });

  }

  function handleTypeSelectCancel() {
    setErrMsg_TypeSelect('');
    setShowTypeSelectDialog(false);
  }

  function handleTypeSelect(type) {

    // Deep copy
    let newObj = JSON.parse (JSON.stringify(objAttrs));
    newObj.typeId  = type.id;
    newObj.typeCode = type.code;

    setObjAttrs(newObj);

    setErrMsg_TypeSelect('');
    setTypeSearchTerm('');
    setShowTypeSelectDialog(false);
  }

  const onTypeSearchInputChange = (e) => {
    setTypeSearchTerm(e.target.value);
  }

  function renderType(type, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{type.code}</td>
        <td style={{width: "40%"}}>{type.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleTypeSelect(type)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }


  // --- Location select dialog stuff ---

  const handleLocPicker = (e, mode) => {
    setLocPickerMode(mode);
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {

    // Deep copy
    let newObj = JSON.parse (JSON.stringify(objAttrs));

    if (locPickerMode === 'LOC') {
      newObj.locId   = location.id;
      newObj.locCode = location.code;
    } else if (locPickerMode === 'SERVICE_LOC') {
      newObj.serviceLocId   = location.id;
      newObj.serviceLocCode = location.code;
    }

    setObjAttrs(newObj);

    setShowLocPickerDialog(false);
  }


  // --- Document select dialog stuff ---

  const handleDocPicker = (e, mode) => {
    setDocPickerMode(mode);
    setErrMsg_DocSelect('');
    setShowDocSelectDialog(true);
  }

  const handleDocSearch = (e) => {
    e.preventDefault();

    if (docSearchTerm === '') {
      setDocSearchTerm('');
      setDocCandidateList([]);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("docs?searchTerms=" + docSearchTerm + "&offset=0&limit=30");

        resolve(res.data);

        if (res.status === 200) {
          if (docPickerMode === 'DOC') {
            // Filter out docs that are already associated with the asset
            if (res.data && res.data.data) {
              if (docList && docList.length > 0) {
                setDocCandidateList (filterArray(res.data.data, docList, "id"));
              } else {
                setDocCandidateList(res.data.data);
              }
            }
          } else {
            setDocCandidateList(res.data.data);
          }
        }

        setErrMsg_DocSelect('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_DocSelect(t(translateAPIError(error)));
        }
      }
    });

  }

  function handleDocSelectCancel() {
    setErrMsg_DocSelect('');
    setShowDocSelectDialog(false);
  }

  function handleDocSelect(doc) {

    if (docPickerMode === 'PHOTO') {
      // Deep copy
      let reqBody = JSON.parse(JSON.stringify(objAttrs));
      reqBody.photoId = doc.id;

//    reqBody.mfrDate       = (mfrDate       ? mfrDate.toISOString()       : "");
      reqBody.handoverDate  = (handoverDate  ? handoverDate.toISOString()  : "");
      reqBody.installDate   = (installDate   ? installDate.toISOString()   : "");
      reqBody.firstUseDate  = (firstUseDate  ? firstUseDate.toISOString()  : "");
      reqBody.warrStartDate = (warrStartDate ? warrStartDate.toISOString() : "");
      reqBody.warrEndDate   = (warrEndDate   ? warrEndDate.toISOString()   : "");


      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosAuth_ASSET_MGMT_API.put("assets/" + objAttrs.id, reqBody);

          resolve(res.data);

          if (res.status === 200) {

            fetchObj(objAttrs.id);

            setErrMsg_DocSelect('');
            setDocSearchTerm('');
            setShowDocSelectDialog(false);
          }
        } catch (error) {
          if (!error.message || (error.message !== 'IGNORE')) {
            setErrMsg(t(translateAPIError(error)));
          }
        }
      });

    } else if (docPickerMode === 'DOC') {

      let reqBody = {
            docList: [{
              id: doc.id,
              role: "TEST_ROLE"
            }]
          };

      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosAuth_ASSET_MGMT_API.post("assets/" + objAttrs.id + "/docs", reqBody);

          resolve(res.data);

          if (res.status === 200) {

            fetchDocs(objAttrs.id);

            setErrMsg_DocSelect('');
            setDocSearchTerm('');
            setShowDocSelectDialog(false);
          }
        } catch (error) {
          if (!error.message || (error.message !== 'IGNORE')) {
            setErrMsg(t(translateAPIError(error)));
          }
        }
      });

    }
  }

  const onDocSearchInputChange = (e) => {
    setDocSearchTerm(e.target.value);
  }

  function renderDocCandidate(doc, index) {

    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{doc.name}</td>
        <td style={{width: "40%"}}>{doc.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleDocSelect(doc)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }


  function handleUnlinkPhoto() {

    // Deep copy
    let reqBody = JSON.parse(JSON.stringify(objAttrs));
    reqBody.photoId = null;

//  reqBody.mfrDate       = (mfrDate       ? mfrDate.toISOString()       : "");
    reqBody.handoverDate  = (handoverDate  ? handoverDate.toISOString()  : "");
    reqBody.installDate   = (installDate   ? installDate.toISOString()   : "");
    reqBody.firstUseDate  = (firstUseDate  ? firstUseDate.toISOString()  : "");
    reqBody.warrStartDate = (warrStartDate ? warrStartDate.toISOString() : "");
    reqBody.warrEndDate   = (warrEndDate   ? warrEndDate.toISOString()   : "");

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.put("assets/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          fetchObj(objAttrs.id);

          setErrMsgUnlinkConfirm('');
          setShowDeleteConfirmDialog(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  function handleViewPhoto() {

    let tmpDocToView = {
          dialogTitle: t("I18N_Asset_cover_photo"),
          viewType:    'IMAGE',
          url:         profilePhoto
        };

    setDocToPreview(tmpDocToView);
    setPreviewDialog(true);
  }


  function handlePreviewDoc(doc) {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_BLDG_DATA_API.get(`/files?path=${encodeURIComponent(doc.path)}`, {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: doc.fileType });
          const blobUrl = URL.createObjectURL(blob);

          let tmpDocToView = {
                dialogTitle: t("I18N_Doc_preview"),
                viewType:    doc.viewType,
                url:         blobUrl
              };

          setDocToPreview(tmpDocToView);
          setPreviewDialog(true);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  function handleDocPreviewDialogCancel() {
    setPreviewDialog(false);
  }

  function handleDownloadPhoto() {

    const nameSplit = objAttrs.photoPath.split("/");
    const fileName = nameSplit.pop();

    const link = document.createElement('a')

    link.href = profilePhoto;
    link.download = "" + fileName + "";
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }


  function handleDownloadDoc(doc) {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_BLDG_DATA_API.get(`/files?path=${encodeURIComponent(doc.path)}`, {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: doc.fileType });
          const blobUrl = URL.createObjectURL(blob);

          const nameSplit = doc.path.split("/");
          const fileName = nameSplit.pop();

          const link = document.createElement('a')

          link.href = blobUrl;
          link.download = "" + fileName + "";
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }



  // --- Upload Doc Related ---

  function renderDocs(doc, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "20%"}}>{doc.name}</td>
        <td style={{width: "25%"}}>{doc.description}</td>
        <td style={{width: "15%"}}>{doc.fileType}</td>
        <td style={{width: "15%"}}><span style={{marginRight:'20px',float:'right'}}>{formatFileSize(doc.size)}</span></td>
        <td style={{width: "20%"}}>{formatDate(doc.timeUpdated)}</td>
        <td style={{width: "5%"}}>
          <span style={{float:'right'}}>
            { doc.viewType !== 'NONE' ?
                <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_View_image")}</Tooltip>}>
                  <span style={{marginLeft:'5px', display:'inline-block', marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                        onClick={event => handlePreviewDoc(doc)}>
                    <HiOutlineEye size={12} />
                  </span>
                </OverlayTrigger>
              : null
            }
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Download_doc")}</Tooltip>}>
              <span style={{marginLeft:'5px', display:'inline-block', marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                    onClick={event => handleDownloadDoc(doc)}>
                <BiDownload size={12} />
              </span>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Unlink_doc")}</Tooltip>}>
              <span style={{marginLeft:'5px', display:'inline-block', marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                    onClick={event => handleDocUnlink(doc)}>
                <BiUnlink size={12} />
              </span>
            </OverlayTrigger>
          </span>
       </td>
      </tr>
    )
  }


  function renderTypeSpecAttrRowEdit(offset) {
    return (
      typeSpecAttrs.length > offset ?
        <>
          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            { typeSpecAttrs[offset + 0] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 0] + "_u")}:</Col> : null }
            { typeSpecAttrs[offset + 1] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 1] + "_u")}:</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 2] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 2] + "_u")}:</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 3] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 3] + "_u")}:</Col> : <Col></Col> }
          </Row>
          <Row className={classes.admin_pages__field_value}>
            { typeSpecAttrs[offset + 0] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 0]} value={objAttrs[typeSpecAttrs[offset + 0]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : null }
            { typeSpecAttrs[offset + 1] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 1]} value={objAttrs[typeSpecAttrs[offset + 1]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : <Col></Col> }
            { typeSpecAttrs[offset + 2] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 2]} value={objAttrs[typeSpecAttrs[offset + 2]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : <Col></Col> }
            { typeSpecAttrs[offset + 3] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 3]} value={objAttrs[typeSpecAttrs[offset + 3]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : <Col></Col> }
          </Row>
        </>
        : null
    );
  }


  function renderTypeSpecAttrRow(offset) {
    return (
      typeSpecAttrs.length > offset ?
        <>
          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            { typeSpecAttrs[offset + 0] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 0] + "_u")}:</Col> : null }
            { typeSpecAttrs[offset + 1] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 1] + "_u")}:</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 2] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 2] + "_u")}:</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 3] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 3] + "_u")}:</Col> : <Col></Col> }
          </Row>
          <Row className={classes.admin_pages__field_value}>
            { typeSpecAttrs[offset + 0] ? <Col>{ objAttrs[typeSpecAttrs[offset + 0]] ? objAttrs[typeSpecAttrs[offset + 0]].toLocaleString(locale) : '--' }</Col> : null }
            { typeSpecAttrs[offset + 1] ? <Col>{ objAttrs[typeSpecAttrs[offset + 1]] ? objAttrs[typeSpecAttrs[offset + 1]].toLocaleString(locale) : '--' }</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 2] ? <Col>{ objAttrs[typeSpecAttrs[offset + 2]] ? objAttrs[typeSpecAttrs[offset + 2]].toLocaleString(locale) : '--' }</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 3] ? <Col>{ objAttrs[typeSpecAttrs[offset + 3]] ? objAttrs[typeSpecAttrs[offset + 3]].toLocaleString(locale) : '--' }</Col> : <Col></Col> }
          </Row>
        </>
        : null
    );
  }


  // --- Photo Upload ---
/*
  const [photoSelectMode, setPhotoSelectMode] = useState(false);
  const [photoAttrs,      setPhotoAttrs]      = useState([]);

  const handleFileChange = (event) => {

    let tmpAttrs = {
          selectedFile: event.target.files[0],
          name:         event.target.files[0].name,
          displayName:  event.target.files[0].name,
          size:         event.target.files[0].size,
          fileType:     event.target.files[0].type,
          path:         "/igc-doc-store/" + event.target.files[0].name
        };

    setPhotoAttrs(tmpAttrs);
    setPhotoSelectMode(true);
  };
*/

/*
  const handleSubmitUpload = (e) => {
    e.preventDefault();

    // Upload document to Document Service

    return new Promise(async (resolve, reject) => {
      try {
        // *** Step 1: Upload the photo (document) to the document server
        const res = await axiosAuth_BLDG_DATA_API.post("/files/upload?path=/igc-doc-store/" + photoAttrs.name + "&mkdir_parents=true/", photoAttrs.selectedFile,
                                                       {
                                                         headers: {
                                                           'Content-Type': photoAttrs.selectedFile.type
                                                         },
                                                       });

        resolve(res.data);

        if (res.status === 201) {

          // Deep copy
          let tmpAttrs = JSON.parse(JSON.stringify(photoAttrs));

          const reqBody = tmpAttrs;

          return new Promise(async (resolve, reject) => {
            try {
              // *** Step 2: Create a metadata record in IGC database
              const res = await axiosAuth_DATA_MGMT_API.post("docs", reqBody);

              resolve(res.data);

              if (res.status === 201) {

                const reqBody = tmpAttrs;

                return new Promise(async (resolve, reject) => {

                  try {
                    // *** Step 3: Create association of the new photo to the asset
                    const res = await axiosAuth_ASSET_MGMT_API.post("assets/" + objAttrs.id + "/docs", reqBody);

                    resolve(res.data);

                    if (res.status === 201) {

                      // Step 3: Create association of the new photo to the asset

                    }
                  } catch (error) {
                    if (!error.message || (error.message !== 'IGNORE')) {
                      setErrMsg(t(translateAPIError(error)));
                    }
                  }
                });

              }
            } catch (error) {
              if (!error.message || (error.message !== 'IGNORE')) {
                setErrMsg(t(translateAPIError(error)));
              }
            }
          });

        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }
*/


  const handleUnlinkDoc = (id) => {

    let reqBody = {
          docIdList: [id]
        };

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.delete("assets/" + objAttrs.id + "/docs", {data: reqBody});

        resolve(res.data);

        if (res.status === 200) {

          fetchDocs(objAttrs.id);

          setErrMsgUnlinkConfirm('');
          setShowDeleteConfirmDialog(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }



  // --- Related to Photo unlink ---
  function handleDocUnlink(doc) {
    setUnlinkTarget(doc);
    setShowDeleteConfirmDialog(true);
  }

  function handleDocUnlinkCancel() {
    setUnlinkTarget(null);
    setErrMsgUnlinkConfirm('');
    setShowDeleteConfirmDialog(false);
  }

  function handleDocUnlinkSubmit() {

    if (unlinkTarget && (unlinkTarget != null)) {
      handleUnlinkDoc(unlinkTarget.id);
    } else {
      handleUnlinkPhoto();
    }
  }


  //--- END ---

  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Asset_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px', maxHeight:'700px', overflowY:'auto'}}>
          <div display='flex'>
            <span>
              {t("I18N_Asset_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>

              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Asset_type")}: *</Col>
                  <Col>{t("I18N_Asset_code")}: *</Col>
                  <Col>{t("I18N_Name")}: *</Col>
                  <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input readOnly className={classes.admin_pages__field_editable} style={{width:'90%'}} name="typeCode" value={objAttrs.typeCode} />
                    <span onClick={handleTypePicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang2" value={objAttrs.nameLang2}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Description")}: </Col>
                  <Col>{t("I18N_Location")}:</Col>
                  <Col>{t("I18N_Service_loc")}:</Col>
                  { configInfo.uiConfig.visibleFields.ASSET_NativeCode ?
                    <Col>{t("I18N_Native_code")}:</Col>
                  : <Col></Col>
                  }
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'65px', backgroundColor:'white'}}
                              name="description" value={objAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input readOnly className={classes.admin_pages__field_editable} style={{width:'90%'}} name="location" value={objAttrs.locCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                    <span onClick={event => handleLocPicker(event, "LOC")} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                  <Col>
                    <input readOnly className={classes.admin_pages__field_editable} style={{width:'90%'}} name="serviceLoc" value={objAttrs.serviceLocCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                    <span onClick={event => handleLocPicker(event, "SERVICE_LOC")} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                  { configInfo.uiConfig.visibleFields.ASSET_NativeCode ?
                    <Col>
                      <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nativeCode" value={objAttrs.nativeCode}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                  : <Col></Col>
                  }
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Brand")}: *</Col>
                  <Col>{t("I18N_Model")}:</Col>
                  <Col>{t("I18N_Model_num")}:</Col>
                  <Col>{t("I18N_Serial_num")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="brand"     value={objAttrs.brand}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="model"     value={objAttrs.model}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="modelNum"  value={objAttrs.modelNum}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="serialNum" value={objAttrs.serialNum}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Mfr")}:</Col>
                  <Col>{t("I18N_Website")}:</Col>
                  <Col>{t("I18N_Country_of_orig")}:</Col>
                  <Col>{t("I18N_Vendor")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="mfr"             value={objAttrs.mfr}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="website"         value={objAttrs.website}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="countryOfOrigin" value={objAttrs.countryOfOrigin}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="vendor"          value={objAttrs.vendor}
                               onChange={(e) => onAttrsInputChange(e)} /> </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Length_mm")}:</Col>
                  <Col>{t("I18N_Width_mm")}:</Col>
                  <Col>{t("I18N_Height_mm")}:</Col>
                  <Col>{t("I18N_Weight_kg")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="length" value={objAttrs.length}
                               onChange={(e) => onAttrsInputChangeInt(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="width"  value={objAttrs.width}
                               onChange={(e) => onAttrsInputChangeInt(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="height" value={objAttrs.height}
                               onChange={(e) => onAttrsInputChangeInt(e)} /> </Col>
                  <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="weight" value={objAttrs.weight}
                               onChange={(e) => onAttrsInputChangeInt(e)} /> </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Handover_date")}:</Col>
                  <Col>{t("I18N_Install_date")}:</Col>
                  <Col>{t("I18N_First_use_date")}:</Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DateTimePicker onChange={onDatepickerChangeHandoverDate} value={handoverDate}
                      format={ (handoverDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={locale}
                    />
                  </Col>
                  <Col>
                    <DateTimePicker onChange={onDatepickerChangeInstallDate} value={installDate}
                      format={ (installDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={locale}
                    />
                  </Col>
                  <Col>
                    <DateTimePicker onChange={onDatepickerChangeFirstUseDate} value={firstUseDate}
                      format={ (firstUseDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={locale}
                    />
                  </Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Warr_start_date")}:</Col>
                  <Col>{t("I18N_Warr_end_date")}:</Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DateTimePicker onChange={onDatepickerChangeWarrStartDate} value={warrStartDate}
                      format={ (warrStartDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={locale}
                    />
                  </Col>
                  <Col>
                    <DateTimePicker onChange={onDatepickerChangeWarrEndDate} value={warrEndDate}
                      format={ (warrEndDate != null) ? "y-MM-dd" : "y-MM-dd" }
                      disableClock="true"
                      clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                      calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                      locale={locale}
                    />
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>

                <hr className="solid" style={{ marginTop: '15px' }}></hr>

                {renderTypeSpecAttrRowEdit(0)}
                {renderTypeSpecAttrRowEdit(4)}
                {renderTypeSpecAttrRowEdit(8)}
                {renderTypeSpecAttrRowEdit(12)}

                <hr className="solid" style={{ marginTop: '15px' }}></hr>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Status")}:</Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={t("common:I18N_ST_" + objAttrs.status)}
                      onSelect={onAssetStatusSelect}>
                      {statusList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("common:I18N_ST_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Asset_code")}:</Col>
                <Col>{t("I18N_Name")}:</Col>
                <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
                <Col>{t("I18N_Description")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.code}</Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.name}
                </Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.nameLang2}
                </Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.description}
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Asset_type")}:</Col>
                <Col>{t("I18N_Location")}:</Col>
                <Col>{t("I18N_Service_loc")}:</Col>
                { configInfo.uiConfig.visibleFields.ASSET_NativeCode ?
                  <Col>{t("I18N_Native_code")}:</Col>
                : <Col></Col>
                }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.typeCode}</Col>
                <Col>{ objAttrs.locCode ? objAttrs.locCode         : '--' }</Col>
                <Col>{ objAttrs.serviceLocCode ? objAttrs.serviceLocCode : '--' }</Col>
                { configInfo.uiConfig.visibleFields.ASSET_NativeCode ?
                  <Col style={{ minWidth: 0 }}>{ objAttrs.nativeCode ? objAttrs.nativeCode   : '--' }</Col>
                : <Col></Col>
                }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Brand")}:</Col>
                <Col>{t("I18N_Model")}:</Col>
                <Col>{t("I18N_Model_num")}:</Col>
                <Col>{t("I18N_Serial_num")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{ objAttrs.brand     ? objAttrs.brand     : '--' }</Col>
                <Col>{ objAttrs.model     ? objAttrs.model     : '--' }</Col>
                <Col>{ objAttrs.modelNum  ? objAttrs.modelNum  : '--' }</Col>
                <Col>{ objAttrs.serialNum ? objAttrs.serialNum : '--' }</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Mfr")}:</Col>
                <Col>{t("I18N_Website")}:</Col>
                <Col>{t("I18N_Country_of_orig")}:</Col>
                <Col>{t("I18N_Vendor")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{ minWidth: 0 }}>{ objAttrs.mfr             ? objAttrs.mfr             : '--' }</Col>
                <Col style={{ minWidth: 0 }}>{ objAttrs.website         ? objAttrs.website         : '--' }</Col>
                <Col style={{ minWidth: 0 }}>{ objAttrs.countryOfOrigin ? objAttrs.countryOfOrigin : '--' }</Col>
                <Col style={{ minWidth: 0 }}>{ objAttrs.vendor          ? objAttrs.vendor          : '--' }</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Length_mm")}:</Col>
                <Col>{t("I18N_Width_mm")}:</Col>
                <Col>{t("I18N_Height_mm")}:</Col>
                <Col>{t("I18N_Weight_kg")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{ objAttrs.length ? objAttrs.length.toLocaleString(locale) : '--' }</Col>
                <Col>{ objAttrs.width  ? objAttrs.width.toLocaleString(locale)  : '--' }</Col>
                <Col>{ objAttrs.height ? objAttrs.height.toLocaleString(locale) : '--' }</Col>
                <Col>{ objAttrs.weight ? objAttrs.weight.toLocaleString(locale) : '--' }</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Handover_date")}:</Col>
                <Col>{t("I18N_Install_date")}:</Col>
                <Col>{t("I18N_First_use_date")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{ objAttrs.handoverDate ? formatDateOnly(objAttrs.handoverDate) : '--' }</Col>
                <Col>{ objAttrs.installDate  ? formatDateOnly(objAttrs.installDate)  : '--' }</Col>
                <Col>{ objAttrs.firstUseDate ? formatDateOnly(objAttrs.firstUseDate) : '--' }</Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Warr_start_date")}:</Col>
                <Col>{t("I18N_Warr_end_date")}:</Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{ objAttrs.warrStartDate ? formatDateOnly(objAttrs.warrStartDate) : '--' }</Col>
                <Col>{ objAttrs.warrEndDate   ? formatDateOnly(objAttrs.warrEndDate)   : '--' }</Col>
                <Col></Col>
                <Col></Col>
              </Row>

              <hr className="solid" style={{ marginTop: '10px' }}></hr>

{/*
              { typeSpecAttrs.length > 0 ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    { typeSpecAttrs[0] ? <Col>{t("I18N_" + typeSpecAttrs[0])}:</Col> : null }
                    { typeSpecAttrs[1] ? <Col>{t("I18N_" + typeSpecAttrs[1])}:</Col> : null }
                    { typeSpecAttrs[2] ? <Col>{t("I18N_" + typeSpecAttrs[2])}:</Col> : null }
                    { typeSpecAttrs[3] ? <Col>{t("I18N_" + typeSpecAttrs[3])}:</Col> : null }
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    { typeSpecAttrs[0] ? <Col>{ objAttrs[typeSpecAttrs[0]] ? objAttrs[typeSpecAttrs[0]] : '--' }</Col> : null }
                    { typeSpecAttrs[1] ? <Col>{ objAttrs[typeSpecAttrs[1]] ? objAttrs[typeSpecAttrs[1]] : '--' }</Col> : null }
                    { typeSpecAttrs[2] ? <Col>{ objAttrs[typeSpecAttrs[2]] ? objAttrs[typeSpecAttrs[2]] : '--' }</Col> : null }
                    { typeSpecAttrs[3] ? <Col>{ objAttrs[typeSpecAttrs[3]] ? objAttrs[typeSpecAttrs[3]] : '--' }</Col> : null }
                  </Row>
                </>
                : null
              }
*/}
              {renderTypeSpecAttrRow(0)}
              {renderTypeSpecAttrRow(4)}
              {renderTypeSpecAttrRow(8)}
              {renderTypeSpecAttrRow(12)}

              <hr className="solid" style={{ marginTop: '10px' }}></hr>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Status")}:</Col>
                <Col>{t("I18N_Photo")}:</Col>
{/*
                <Col>{t("I18N_QR_code")}:</Col>
*/}
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{t("I18N_ST_" + objAttrs.status)}</Col>
                <Col>
                  <div style={{display:'flex'}}>
<div>
{/*
                  { !photoSelectMode ?
                       profilePhoto ?
                          <span><img alt="AAA" style={{marginTop:'5px', maxWidth:'100px', maxHeight:'100px', borderRadius:'3px', border: '1px solid lightGray'}}
                                    src={profilePhoto} /></span>
                        :
                          <span><img alt="AAA" style={{marginTop:'5px', maxWidth:'100px', maxHeight:'100px'}} src={ahuPhoto} /></span>

                    :
                     <input readOnly className={classes.admin_pages__field_editable} name="name" value={photoAttrs.name} />
                  }
*/}
                  { profilePhoto ?
                      <span><img alt="Profile_image" style={{marginTop:'5px', maxWidth:'100px', maxHeight:'100px', borderRadius:'3px', border: '2px solid lightGray'}}
                                src={profilePhoto} /></span>
                    :
                      <span><BiImage size={50} style={{color:'#A0A0A0'}}/></span>
                  }

{/*
                  <OverlayTrigger overlay={<Tooltip id="tooltip-upload-doc" style={{fontSize:'11px'}}>{t("I18N_TIP_Upload_photo")}</Tooltip>}>
                    <span style={{marginLeft:'15px', display:'inline-block', marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                          onClick={() => document.getElementById('fileInput').click()}>
                      <BiUpload size={12} />
                    </span>

                    <span>
                      <input
                        type="file"
                        style={{ display: 'none' }}
                        id="fileInput"
                        onChange={handleFileChange}
                      />
                      <span style={{marginLeft:'15px', display:'inline-block', marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}>
                        <BiUpload size={12} onClick={() => document.getElementById('fileInput').click()}/>
                      </span>
                    </span>

                  </OverlayTrigger>
*/}
</div>

                      <div>
                  { profilePhoto ?
                     <div style={{display:'grid', marginLeft:'15px'}}>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_View_photo")}</Tooltip>}>
                          <div style={{marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                                onClick={event => handleViewPhoto()}>
                            <HiOutlineEye size={12} />
                          </div>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Download_photo")}</Tooltip>}>
                          <div style={{marginTop:'3px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                                onClick={event => handleDownloadPhoto()}>
                            <BiDownload size={12} />
                          </div>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Unlink_photo")}</Tooltip>}>
                          <div style={{marginTop:'3px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                                onClick={event => handleDocUnlink(null)}>
                            <BiUnlink size={12} />
                          </div>
                        </OverlayTrigger>
                      </div>
                    :
                      <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Link_photo")}</Tooltip>}>
                        <span style={{marginLeft:'5px', display:'inline-block', marginTop:'0px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}}
                              onClick={event => handleDocPicker(event, "PHOTO")}>
                          <BiLink size={12} />
                        </span>
                      </OverlayTrigger>
                  }

{/*
                  <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_photo")}</Tooltip>}>
                    <span style={{marginLeft:'5px', verticalAlign:'top', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                      <BiTrash size={12} />
                    </span>
                  </OverlayTrigger>
*/}
                      </div>
                  </div>
                </Col>
{/*
                <Col>{ objAttrs.code ? <QRCode style={{marginTop:'5px', maxWidth:'80px', maxHeight:'80px'}} value={objAttrs.code} /> : null }</Col>
*/}
                <Col></Col>
                <Col></Col>
              </Row>

              <hr className="solid" style={{ marginTop: '10px' }}></hr>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Updated_by")}:</Col>
                  <Col>{t("I18N_Time_updated")}:</Col>
                  <Col>{t("I18N_Created_by")}:</Col>
                  <Col>{t("I18N_Time_created")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.updaterUsername}</Col>
                <Col>{formatDate(objAttrs.timeUpdated)}</Col>
                <Col>{objAttrs.creatorUsername}</Col>
                <Col>{formatDate(objAttrs.timeCreated)}</Col>
              </Row>
            </Container>
          }
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Documents")}
            </span>

            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Link_doc")}</Tooltip>}>
                <span onClick={event => handleDocPicker(event, "DOC")} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiLink size={18} />
                </span>
              </OverlayTrigger>
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Doc_name")}</th>
                  <th style={{width:'25%', fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_File_type")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}><span style={{marginRight:'20px',float:'right'}}>{t("I18N_File_size")}</span></th>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Time_added")}</th>
                  <th style={{width:'5%'}}></th>
                </tr>
              </thead>
              <tbody>
                {(docList && docList.length > 0) ? docList.map(renderDocs) : null}
              </tbody>
            </Table>
          </div>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>


        <Modal show={showTypeSelectDialog} onHide={handleTypeSelectCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Type_picker")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Code")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Form onSubmit={handleTypeSearch}>
                      <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="typeSearchTerm" value={typeSearchTerm}
                                    onChange={(e) => onTypeSearchInputChange(e)} />
                    </Form>
                  </Col>
                  <Col>
                    <span onClick={handleTypeSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(typeList && typeList.length > 0) ? typeList.map(renderType) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_TypeSelect}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleTypeSelectCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>
            </div>
          </Modal.Body>
        </Modal>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />


        <Modal show={showDocSelectDialog} onHide={handleDocSelectCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Doc_picker")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Doc_name")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Form onSubmit={handleDocSearch}>
                      <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="docSearchTerm" value={docSearchTerm}
                                    onChange={(e) => onDocSearchInputChange(e)} />
                    </Form>
                  </Col>
                  <Col>
                    <span onClick={handleDocSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Doc_name")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(docCandidateList && docCandidateList.length > 0) ? docCandidateList.map(renderDocCandidate) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_DocSelect}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleDocSelectCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>
            </div>
          </Modal.Body>
        </Modal>


        <Modal show={showDocPreviewDialog} onHide={handleDocPreviewDialogCancel} centered size="lg" >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                <span style={{fontSize:'16px'}}>
                  { docToPreview ? docToPreview.dialogTitle : ''}
                </span>
                <span>
                  <MdClose style={{ marginLeft:'auto', marginRight:'-2px', color:'#333', float:'right', cursor:'pointer'}} size={16}
                           onClick={handleDocPreviewDialogCancel}/>
                </span>
              </span>

              <Row>
                { (docToPreview && (docToPreview.viewType === 'IMAGE')) ?
                    <img alt="AAA" style={{padding:'10px', maxWidth:'800px', maxHeight:'800px', borderRadius:'3px'}}
                         src={docToPreview.url} />
                  : (docToPreview && (docToPreview.viewType === 'PDF')) ?
                    <iframe title="Doc Preview" style={{padding:'10px', width:'800px', height:'80vh', borderRadius:'3px'}}
                         src={docToPreview.url} />
                  : null
                }
              </Row>
            </div>
          </Modal.Body>
        </Modal>

        <DeleteConfirmDialog
          title={unlinkTarget ? t("I18N_Unlink_doc_confirm") : t("I18N_Unlink_photo_confirm")}
          show={showDeleteConfirmDialog}
          targetName={unlinkTarget ? unlinkTarget.name : ''}
          errMsgUnlinkConfirm={errMsgUnlinkConfirm}
          onCancel={handleDocUnlinkCancel}
          onSubmit={handleDocUnlinkSubmit}
        />

      </Card>
    </>
  );
}

export default AssetAdminDetailsView;
